import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { ModalService } from 'ng-bootstrap-modal';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupService } from '../signup/service/signup.service';
import { ServiceUrlsService } from '../common-service/service-urls/service-urls.service';


@Component({
  selector: 'app-signup-dialog',
  templateUrl: './signup-dialog.component.html',
  styleUrls: ['./signup-dialog.component.scss']
})
export class SignupDialogComponent implements OnInit {

  signupForm: FormGroup;
  isSignupError = false;
  signUpErrorMessage: string;
  signUpSuccessMessage: string;
  signUpSuccess = false;
  verificationEmailSent= false;
  showAlreadyRegisteredForm = false;



  contactEmail : string;

  @ViewChild('signupFormElement')
  private signupFormElement: ElementRef;

  @ViewChild('resendVerificationEmailForm')
  private resendVerificationEmailForm: ElementRef;

  constructor(private modalService:ModalService,
                  private fb: FormBuilder,
                  private signupService: SignupService,
                  private router: Router,
                  private activeRoute: ActivatedRoute,
                  private spinnerService: NgxSpinnerService,
                  private serviceUrlsService: ServiceUrlsService) {
    }

    ngOnInit() {
      this.isSignupError = false;
      this.signUpSuccess =  false;
      this.verificationEmailSent = false;
      this.showAlreadyRegisteredForm =  false;
      this.signUpErrorMessage = '';
      this.signUpSuccessMessage = '';
      this.buildForm();
    }

    submit() {
         this.modalService.ok();

    }
    cancel() {
         this.modalService.cancel();
    }

    buildForm() {

      this.signupForm = this.fb.group({
        contactName: ['', Validators.required],
        contactEmail: ['', [
            Validators.required,
            Validators.email
          ]
        ],
        clientName: ['', Validators.required],
        contactPhone: [''],
        acceptTermsAndPrivacy: [false, Validators.required],
        recaptcha: false
      });

    }

    sumbitSignup() {

      console.log(this.signupForm.value);

      let signupFormData = this.signupForm.value;

      const signUpObject = {contactName: signupFormData.contactName, contactEmail: signupFormData.contactEmail,
                            clientName: signupFormData.clientName, contactPhone: signupFormData.contactPhone,
                            clientType: '',
                           };

     console.log(signUpObject);

      this.spinnerService.show();

       this.signupService.signup(signUpObject).subscribe(response => {
          let code = response.code;
          console.log(response);
          if (code === '200' || code === 200) {
              this.spinnerService.hide();
              this.signUpSuccess = true;
              // this.router.navigate(['signup-success', signupFormData.contactEmail]);
          } else {
              this.isSignupError =  true;
              this.signUpErrorMessage = response.message;
              this.spinnerService.hide();
          }
      },
        err => {
              console.log(err);
             this.isSignupError =  true;
             this.signUpErrorMessage = err.errorMessage;
             this.spinnerService.hide();
      });

    }

    // resendVerificationEmail() {
    //   //this.verificationEmailSent =  true;
    //   this.signUpErrorMessage =  'Testing MESSAGE ........';
    //   this.isSignupError =  true;
    //
    //
    // }

    onScriptLoad() {
          //console.log('Google reCAPTCHA loaded and is ready for use!')
    }

    onScriptError() {
         // console.log('Something went long when loading the Google reCAPTCHA')
    }

    generateVerificationCode(length): string {

       let text = "";
       const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

       for (var i = 0; i < length; i++) {
           text += possible.charAt(Math.floor(Math.random() * possible.length));
       }

       return text;
    }

    clickAlreadyRegistered() {
        this.isSignupError =  false;
        this.showAlreadyRegisteredForm =  true;
        //console.log(this.signupFormElement.nativeElement.classList.add('hide'));

        this.signupFormElement.nativeElement.classList.add('hide')
        //this.resendVerificationEmailForm.nativeElement.classList.remove('hide')
       //this.signupFormElement.nativeElement.add('hide');
    }

    clickSignUpLink() {
       this.isSignupError =  false;
       this.showAlreadyRegisteredForm =  false;
       this.signupFormElement.nativeElement.classList.remove('hide')
       //this.resendVerificationEmailForm.nativeElement.classList.add('hide')
    }

resendVerificationEmail() {

      //console.log(this.contactEmail);

      let clientObject = {contactEmail: this.contactEmail};

      this.isSignupError =  false;

      this.spinnerService.show();

       this.signupService.resendVerificationEmail(clientObject).subscribe(response => {
          let code = response.code;
          console.log(response);
          if (code === '200' || code === 200) {
              this.signUpErrorMessage = response.message;
              this.spinnerService.hide();
              this.verificationEmailSent = true;
              // this.router.navigate(['signup-success', signupFormData.contactEmail]);
          } else {
              this.isSignupError =  true;
              this.signUpErrorMessage = response.message;
              this.spinnerService.hide();
          }
      },
        err => {
              console.log(err);
             this.isSignupError =  true;
             this.signUpErrorMessage = err.errorMessage;
             this.spinnerService.hide();
      });

    }

  termsOfPrivacyPolicy() {
      window.open(this.serviceUrlsService.wesiteBaseUrl + 'privacy-policy');
  }

}



// WEBPACK FOOTER //
// ./src/app/signup-dialog/signup-dialog.component.ts